var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sellsy-ai-loader" }, [
    _c("div", { staticClass: "sellsy-ai-loader__circle" }, [_c("AILoader")], 1)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }